<template>
    <div
        class="ct-offcanvas-panel map-add-feature-panel"
        :style="{ 'margin-bottom': panelBottom}"
        v-show="show">
        <button
            v-if="!isActionNewOccurrence"
            type="button"
            :disabled="isActionNewOccurrence"
            @click.prevent="onStartProcess"
            class="btn btn-rounded btn-responsive btn-lg btn-tertiary-main btn-add-feature">
            {{ txtAddTitleButton }}
        </button>
        <template v-else>
            <DrawAndUpload
                :idPanel="idPanel"
                :baseTranslateID="baseTranslateID"
                :moduleCode="moduleCode"
                :panelCfg="panelTool"
                :url="url"
                :acl="acl"
                :map="map"
                :drawTypes="drawTypes"
                :enableDraw="enableDraw"
                :enableImport="enableImport"
                uploadMsgClass="small"
                @onConfirm="onConfirmGeometry"
                @onCancel="onCancelProcess"
            />
        </template>
    </div>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import { MAP_ACTIONS } from '@config/constants';
    import { EVENTS } from '@/app/shared/utils/constants';
    import { getCenter as getCenterExtent } from 'ol/extent';
    import VectorImageLayer from 'ol/layer/VectorImage';
    import VectorLayer from 'ol/layer/Vector'
    import { GeoJSON } from 'ol/format';
    import Feature from 'ol/Feature';
    import Point from 'ol/geom/Point';

    let vars = {
        defaultIdControl: 'addfeature',
    };

    export default {
        hiddenLayers: [],
        mixins: [
            ButtonControlMixin
        ],
        components:{
            DrawAndUpload: () => import(/* webpackChunkName: "draw-upload" */ '@/app/shared/components/maps/components/DrawAndUpload'),
        },
        props: {
            // label: {
            //     type: String,
            //     require: true
            // },
            idControl: {
                type: String,
                default: vars.defaultIdControl,
            },
            baseTranslateID: {
                type: String,
                default: null,
            },
            actionName: {
                type: String,
                default: MAP_ACTIONS.NEW_OCCURRENCE,
            },
            cancelTitleButton: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.cancel`
            },
            saveTitleButton: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.save`
            },
            infoLocal: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.help`
            },
            infoNoPermission: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.not_allowed`
            },
            infoOutside: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.out_boundary`
            },
            infoAtiveFilter: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.active_filter`
            },
            infoAddressNotFount: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.address_not_found`
            },
            infoModifyPosition: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.modify_position`
            },
            forceAutenticatedOnCreate: {
                type: Boolean,
                default: true,
            },
            eventInitialize: {
                type: String,
                default: EVENTS.INITIALIZE_NEW_FEATURE,
            },
            eventCanceled: {
                type: String,
                default: EVENTS.CANCELED_NEW_FEATURE,
            },
            eventConfirmGeometry: {
                type: String,
                default: EVENTS.CONFIRM_GEOMETRY_NEW_FEATURE,
            },
            eventFinished: {
                type: String,
                default: EVENTS.FINISHED_NEW_FEATURE,
            },
            eventMyGeolocationCoordinates: {
                type: String,
                default: EVENTS.MY_GEO_LOCATION_COORDINATES,
            },  
            eventMyGeolocationCoordinatesFeature: {
                type: String,
                default: EVENTS.MY_GEO_LOCATION_COORDINATES_Feature,
            },         
            eventShowModal: {
                type: String,
                default: EVENTS.SHOW_MODAL_NEW_FEATURE,
            },
            drawTypes: {
                type: [String, Array],
                default: () => ['point', 'line', 'polygon'],
                validator: function (prop) {
                    let valid = [
                        'point',
                        // 'text',
                        'line',
                        'freehand',
                        'freehand-shape',
                        'ellipse',
                        'circle',
                        'polygon',
                        'rectangle',
                        'square',
                    ];
                    if(typeof prop === "string"){
                        return valid.includes(prop);
                    }
                    return prop.every(e => valid.includes(e));
                }
            },
        },
        data() {
            return {
                idPanel: this.idControl,
                idFilterTypePanel: 'filtertype',
                bottom: 0,
                show: true,
            }
        },
        computed: {
            panelTool(){
                return this.tool?.panel ?? {};
            },
            txtAddTitleButton(){
                return this.$t(this.title);
            },
            // txtCancelTitleButton(){
            //     return this.$t(this.panelTool.cancelTitleFeature ? this.panelTool.cancelTitleFeature : this.cancelTitleButton);
            // },
            // txtSaveTitleButton(){
            //     return this.$t(this.panelTool.saveTitleFeature ? this.panelTool.saveTitleFeature : this.saveTitleButton);
            // },
            infoLocalAddFeature(){
                return this.$t(this.panelTool.infoAddFeature ? this.panelTool.infoAddFeature : this.infoLocal);
            },
                // infoOutsideAddFeature(){
                //     return this.$t(this.panelTool.infoOutsideAddFeature ? this.panelTool.infoOutsideAddFeature : this.infoOutside);
                // },
                // infoAtiveFilterFeature(){
                //     return this.$t(this.panelTool.infoAtiveFilterFeature ? this.panelTool.infoAtiveFilterFeature : this.infoAtiveFilter);
                // },
            infoNoPermissionAddFeature(){
                return this.$t(this.panelTool.infoNoPermissionAddFeature ? this.panelTool.infoNoPermissionAddFeature : this.infoNoPermission);
            },
                // infoAddressNotFountFeature(){
                //     return this.$t(this.panelTool.infoAddressNotFountFeature ? this.panelTool.infoAddressNotFountFeature : this.infoAddressNotFount);
                // },
            isActionNewOccurrence() {
                return this.$store.getters.getAction(this.moduleCode) == this.actionName;
            },
            enableUpdateBottom() {
                return false; //this.themeLayoutConfig.map.updateMapButtonPositionBottom && !detectMobile();
            },
            panelBottom(){
                return this.enableUpdateBottom ? this.bottom : null; //'inherit'
            },
            userFeature() {
                return this.$store.getters[`${this.moduleCode}/getUserFeatureMap`];
            },
            filterTypePanel(){
                return this.$store.getters[`${this.moduleCode}/getPanel`](this.idFilterTypePanel);
            },
            collapsedFilterTypePanel() {
                return !!this.filterTypePanel.collapsed;
            },
            heightFilterTypePanel() {
                return this.filterTypePanel.height;
            },
            configMap() {
                return this.moduleCode ? this.$store.getters[`${this.moduleCode}/getConfigMap`] : {};
            },
            layersProperties() {
                return this.configMap?.layers?.new_feature ?? {};
            },
            sourceId() {
                return this.layersProperties.source || {};
            },
            layerId() {
                return this.layersProperties.layer || {};
            },
            map() {
                return this.getMap();
            },
            enableDraw() {
                return true;
            },
            enableImport() {
                return this.checkUserHasPermission(this.acl.allowUploadGeometry);
            },
        },
        created() {
            this.$eventBus.listen(this.moduleCode, this.eventFinished, this.onFinishedNewFeature);
            this.$eventBus.listen(this.moduleCode, this.eventMyGeolocationCoordinates, this.onReceiveMyLocationCoordinates);    
        },
        beforeDestroy() {
            this.$eventBus.remove(this.moduleCode, this.eventFinished, this.onFinishedNewFeature);
            this.$eventBus.remove(this.moduleCode, this.eventMyGeolocationCoordinates, this.onReceiveMyLocationCoordinates);
            this.reset();
        },
        methods: {
            initialize: function() {
                if(!this.mapInitialized) return;
            },
            reset: function(){
                this.clearMessages();
                for (let i = 0, len = this.$options.hiddenLayers.length; i < len; ++i) {
                    let layer = this.$options.hiddenLayers[i];
                    layer.setVisible(true);
                }
                this.setAction(true);
            },
            updateBottomMargin(collapsed) {
                const refHeight = this.heightFilterTypePanel;
                // this.bottom = this.bottom == 'auto' ? this.bottom : refHeight + 'px !important';
                this.bottom = refHeight + 'px !important';
            },
            onStartProcess: function() {
                if(this.isActionNewOccurrence){
                    return false;
                }
                if(this.forceAutenticatedOnCreate){
                    let isAutenticated = this.$auth.check();
                    if(!isAutenticated){
                        this.onCancelProcess();
                        this.$router.push({name: 'portal.login'})
                        return;
                    }
                }

                if (this.checkUserHasPermission(this.acl.view)) {
                    this.onInitializeNewFeature();
                } else {
                    this.showError(this.infoNoPermissionAddFeature)
                }
            },
            onCancelProcess: function() {
                this.reset();
                this.$eventBus.publish(this.moduleCode, this.eventCanceled);
                this.$eventBus.publish(this.moduleCode, this.eventFinished);
            },
            onReceiveMyLocationCoordinates(geolocationCoordinates) {
                this.onStartProcess();
                 // criar feature
                 const feature = new Feature({
                     geometry: new Point(geolocationCoordinates),
                     _geom: "point"
                });
                setTimeout(() => {
                    this.$eventBus.publish(this.moduleCode, this.eventMyGeolocationCoordinatesFeature,feature);
                 }, 1000); // 1 segundo
                
                this.$root.$emit("openConfirmation", {
                    id: null,
                    data: feature,
                    text: this.$t(`occurrence.form.msg.confirm.my_geo_location_ocurrence`),
                    callback: data => {
                        this.onConfirmGeometry({ features: [feature] });
                    },
                    cancel: () => {
                        this.onCancelProcess();
                    },
            });
        },
            onConfirmGeometry: function(params) {
                const {features = []} = params;
                this.clearMessages();
                this.dispatchEventConfirmGeometry({feature: features.length ? features[0] : null});
            },
            onInitializeNewFeature: function() {
                this.$eventBus.publish(this.moduleCode, this.eventInitialize);

                const _map = this.getMap();
                if(!_map){
                    return;
                }
                // this.onFinishedNewFeature();
                let layers = _map.getLayers().getArray();
                for (let i = 0, len = layers.length; i < len; ++i) {
                    let layer = layers[i];
                    if(layer == _map.getLayer(this.layerId)) continue;
                    let visible = layer.getVisible();
                    if(visible){
                        //If this is a vector layer
                        if(layer instanceof VectorLayer
                            || layer instanceof VectorImageLayer){
                            // groupLyr instanceof ol.layer.Group;
                            // groupLyr instanceof ol.layer.Vector;
                            layer.setVisible(false);
                            this.$options.hiddenLayers.push(layer);
                        }
                    }
                }

                this.setAction();
                this.showMessage(this.infoLocalAddFeature);
            },
            onFinishedNewFeature: function() {
                this.reset();
            },
            escapeHandler: function(evt) {
                if(evt instanceof KeyboardEvent) {
                    if (evt.key === 'Escape') {
                        this.onFinishedNewFeature();
                    }
                }
            },
            async setUserFeatureMap(data) {
                await this.$store.dispatch(`${this.moduleCode}/setUserFeatureMap`, data);
            },
            setAction: function(reset=false) {
                if(reset) {
                    this.setUserFeatureMap(null);
                }
                this.$store.dispatch(`setAction`, {module: this.moduleCode, action: reset ? null : this.actionName});
            },
            dispatchEventConfirmGeometry: function(params) {
                const _map = this.getMap();
                if(!_map){
                    return;
                }

                let feature = null;
                if(params.feature) {
                    feature = params.feature;
                }else if(params.features) {
                    if(params.features.getLength()>0) {
                        feature = params.features.item(0);
                    }
                }

                if(this.eventConfirmGeometry && feature) {
                    let geojson = (new GeoJSON()).writeFeatureObject(feature);
                    let crs = _map.getProjection().getCode().split(':').pop();
                    let resolution = _map.getResolution();
                    let featureExtent = feature?.getGeometry()?.getExtent() ?? null;
                    let center = featureExtent ? getCenterExtent(featureExtent) : null;

                    this.$eventBus.publish(this.moduleCode, this.eventConfirmGeometry, {
                        data: {
                            id: feature.getId(),
                            crs,
                            resolution,
                            center,
                            feature,
                            geojson,
                        }
                    });
                }
            }
        },
        watch: {
            isActionNewOccurrence: {
                immediate: false,
                handler(value, oldVal) {
                    if(value) {
                        this.initialize();
                    }else{
                        this.reset();
                    }
                },
            },
            userFeature: {
                immediate: false,
                handler(value, oldVal) {
                    if(value){
                        this.$eventBus.publish(this.moduleCode, this.eventShowModal);
                    }
                },
            },
            heightFilterTypePanel: {
                immediate: true,
                handler(value, oldValue){
                    this.updateBottomMargin(value);
                },
            },
        },

    }
</script>

<style lang="scss" scoped>
@import "@styles/bootstrap/_mixins.scss";
@import "@styles/_mixins.scss";
@import "@styles/_theme.scss";

    .btn-add-feature {
        &[class*="btn-outline-"] {
            background-color: #ffffff !important;
        }
    }
    .map-add-feature-panel {
        position: absolute;
        top: $tools-addfeature-top-default;
        bottom: $tools-addfeature-bottom-default;
        left: $tools-addfeature-left-default;
        right: $tools-addfeature-right-default;

        z-index: 1;
        margin-inline: auto;
        width: fit-content;
        text-align: center;

        @include sm {
            width: auto;
            bottom: $tools-addfeature-bottom-sm;
            left: $tools-addfeature-left-sm;
            right: $tools-addfeature-right-sm;
            top: $tools-addfeature-top-sm;
            max-width: 360px;
        }
        /* @include lg {
            right: $tools-addfeature-right + 1rem;
        } */

        -webkit-transition: bottom 1s ease !important;
        -moz-transition: bottom 1s ease !important;
        -ms-transition: bottom 1s ease !important;
        -o-transition: bottom 1s ease !important;
        transition: bottom 1s ease !important;

        &.w-panel-filters {
            margin-bottom: 1.7rem;
        }
    }
</style>